import {
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  FORGOT_PASSWORD_START,
  FORGOT_PASSWORD_SUCCESS,
  RESET_PASSWORD_START,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR
} from './login.actions';
import initialState from './login.initialState';

export default function loginReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_START:
      return {
        ...state,
        loading: true
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        loggedIn: true
      };
    case LOGIN_ERROR:
      return {
        ...state,
        loading: false
      };
    case FORGOT_PASSWORD_START:
      return {
        ...state,
        forgotPasswordLoading: true,
        forgotPasswordSuccess: false
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordSuccess: true
      };
    case RESET_PASSWORD_START:
      return {
        ...state,
        resetPasswordLoading: true,
        resetPasswordSuccess: false
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordSuccess: true
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordSuccess: false
      };
    default:
      return state;
  }
}
